export var PRESS_EVENT_TIMER_NAME = 'pressEvent';
export var TAP_GESTURE_TIMER_NAME = 'tap';
export var MOUSE_EMULATION_GUARD_TIMER_NAME = 'mouseEmulation';
export var SET_ACTIVATION_TIMER_NAME = 'setHovering';
export var UNSET_ACTIVATION_TIMER_NAME = 'unsetHovering';
export var INTERACTIONS = {
    TOUCH: 'touch',
    TAP: 'tap',
    DOUBLE_TAP: 'double_tap',
    PRESS: 'press',
    CLICK: 'click',
    HOVER: 'hover'
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-cursor-position/dist/es/constants.js
// module id = 119
// module chunks = 0